import { render, staticRenderFns } from "./OnePaymentRun.vue?vue&type=template&id=0b604741&scoped=true"
import script from "./OnePaymentRun.vue?vue&type=script&lang=js"
export * from "./OnePaymentRun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b604741",
  null
  
)

export default component.exports